import { render, staticRenderFns } from "./CardapioPedidoTuor.vue?vue&type=template&id=18de87c4&scoped=true&"
import script from "./CardapioPedidoTuor.vue?vue&type=script&lang=js&"
export * from "./CardapioPedidoTuor.vue?vue&type=script&lang=js&"
import style0 from "./CardapioPedidoTuor.vue?vue&type=style&index=0&id=18de87c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de87c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VSpacer})
